/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebAuthnAttestation = {
    None: 'none',
    Indirect: 'indirect',
    Direct: 'direct'
} as const;
export type WebAuthnAttestation = typeof WebAuthnAttestation[keyof typeof WebAuthnAttestation];


export function WebAuthnAttestationFromJSON(json: any): WebAuthnAttestation {
    return WebAuthnAttestationFromJSONTyped(json, false);
}

export function WebAuthnAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnAttestation {
    return json as WebAuthnAttestation;
}

export function WebAuthnAttestationToJSON(value?: WebAuthnAttestation | null): any {
    return value as any;
}

